import { Component, Input, OnChanges } from '@angular/core';
import { FilterTypeDuplicatesModel } from '../../models/filter-type-duplicates.model';
import { DuplicatesStatusEnum } from '../../enums/duplicates-status.enum';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';

@Component({
    selector: 'agpr-filter-duplicates',
    templateUrl: './filter-duplicates.component.html',
    styleUrls: ['./filter-duplicates.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterDuplicatesComponent
        }
    ],
    standalone: false
})
export class FilterDuplicatesComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterTypeDuplicatesModel;

    value: DuplicatesStatusEnum;

    showDuplicates: boolean = false;
    groupDuplicates: boolean = false;

    ngOnChanges(): void {
        this.refresh();
    }

    /**
     * Refreshes the current value of the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
        this.showDuplicates = this.value === DuplicatesStatusEnum.show || this.value === DuplicatesStatusEnum.group;
        this.groupDuplicates = this.value === DuplicatesStatusEnum.group;
    }

    /**
     * Converts values from the inputs into the appropriate enum
     */
    handleChange(): void {
        if (this.showDuplicates) {
            if (this.groupDuplicates) {
                this.value = DuplicatesStatusEnum.group;
            } else {
                this.value = DuplicatesStatusEnum.show;
            }
        } else {
            this.value = DuplicatesStatusEnum.hide;
            this.groupDuplicates = false;
        }

        this.filter.setCurrentValue(this.value);
    }
}
